import {
    UPDATE_CLIENT,
    BLOCK_CLIENT,
    UPDATE_CLIENT_RANK,
    UPDATE_CLIENT_EMAIL,
    UPDATE_CLIENT_PASSWORD,
    ACTIVE_CLIENT,
  } from './types';
  import axios from 'axios';
  import { mainDomain } from './../mainConf';
  
  export const editClient = (
    client,
    isTakingAgencyRole,
    takenAgencyRoleToken,
    processType
  ) => async (dispatch) => {
    let c= client.agency;
    let d= {}
    d.client=c;
    let res = {};
    let errorRes = {
      errorStatus: '',
      errorMessage: '',
    };
    var token = '';
    if (isTakingAgencyRole) {
      token = takenAgencyRoleToken;
    } else {
      token = localStorage.getItem('ikar_token');
    }
    await axios
      .put(
        `${mainDomain}/v1/admin/client/update`,
        d,
        // ,
        // {
        //   withCredentials: true,
        // }
        {
          headers: {
            Accept: 'application/json',
            //'Content-Type': 'application/json',
            //'Access-Control-Allow-Origin': '*',
            //'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,OPTIONS',
            Authorization: token,
          },
        }
      )
      .then(function (response) {
        if (
          response !== null &&
          response !== undefined &&
          Object.keys(response).length > 0
        ) {
          res = response.data;
          res.message = processType;
        } else res = {};
      })
      .catch(function (error) {
        if (error.response) {
          errorRes = {
            errorStatus: error.response.status,
            errorMessage: error.response,
          };
        } else if (error.request) {
          errorRes = {
            errorMessage: error.request,
          };
        } else {
          errorRes = { errorMessage: error.message };
        }
        res = errorRes;
      });
    dispatch({
      type: UPDATE_CLIENT,
      payload: res,
    });
  };
  
  export const editClientRank = (
    client,
    isTakingAgencyRole,
    takenAgencyRoleToken,
    processType
  ) => async (dispatch) => {
    let res = {};
    let errorRes = {
      errorStatus: '',
      errorMessage: '',
    };
    var token = '';
    if (isTakingAgencyRole) {
      token = takenAgencyRoleToken;
    } else {
      token = localStorage.getItem('ikar_token');
    }
  
    await axios
      .put(
        `${mainDomain}/v1/admin/client/edit_rank`,
        client,
        // ,
        // {
        //   withCredentials: true,
        // }
        {
          headers: {
            Accept: 'application/json',
            //'Content-Type': 'application/json',
            //'Access-Control-Allow-Origin': '*',
            //'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,OPTIONS',
            Authorization: token,
          },
        }
      )
      .then(function (response) {
        if (
          response !== null &&
          response !== undefined &&
          Object.keys(response).length > 0
        ) {
          res = response.data;
          res.message = processType;
        } else res = {};
      })
      .catch(function (error) {
        if (error.response) {
          errorRes = {
            errorStatus: error.response.status,
            errorMessage: error.response,
          };
        } else if (error.request) {
          errorRes = {
            errorMessage: error.request,
          };
        } else {
          errorRes = { errorMessage: error.message };
        }
        res = errorRes;
      });
    dispatch({
      type: UPDATE_CLIENT_RANK,
      payload: res,
    });
  };
  
  export const editClientEmail = (
    client,
    isTakingAgencyRole,
    takenAgencyRoleToken,
    processType
  ) => async (dispatch) => {
    let res = {};
    let errorRes = {
      errorStatus: '',
      errorMessage: '',
    };
    var token = '';
    if (isTakingAgencyRole) {
      token = takenAgencyRoleToken;
    } else {
      token = localStorage.getItem('ikar_token');
    }
  
    await axios
      .post(
        `${mainDomain}/v1/users/email/update`,
        client,
        // ,
        // {
        //   withCredentials: true,
        // }
        {
          headers: {
            Accept: 'application/json',
            //'Content-Type': 'application/json',
            //'Access-Control-Allow-Origin': '*',
            //'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,OPTIONS',
            Authorization: token,
          },
        }
      )
      .then(function (response) {
        if (
          response !== null &&
          response !== undefined &&
          Object.keys(response).length > 0
        ) {
          res = response.data;
          res.message = processType;
        } else res = {};
      })
      .catch(function (error) {
        if (error.response) {
          errorRes = {
            errorStatus: error.response.status,
            errorMessage: error.response,
          };
        } else if (error.request) {
          errorRes = {
            errorMessage: error.request,
          };
        } else {
          errorRes = { errorMessage: error.message };
        }
        res = errorRes;
      });
    dispatch({
      type: UPDATE_CLIENT_EMAIL,
      payload: res,
    });
  };
  
  export const editClientPassword = (
    client,
    isTakingAgencyRole,
    takenAgencyRoleToken,
    processType
  ) => async (dispatch) => {
    let res = {};
    let errorRes = {
      errorStatus: '',
      errorMessage: '',
    };
    var token = '';
    if (isTakingAgencyRole) {
      token = takenAgencyRoleToken;
    } else {
      token = localStorage.getItem('ikar_token');
    }
  
    await axios
      .post(
        `${mainDomain}/v1/users/pwd/update`,
        client,
        // ,
        // {
        //   withCredentials: true,
        // }
        {
          headers: {
            Accept: 'application/json',
            //'Content-Type': 'application/json',
            //'Access-Control-Allow-Origin': '*',
            //'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,OPTIONS',
            Authorization: token,
          },
        }
      )
      .then(function (response) {
        if (
          response !== null &&
          response !== undefined &&
          Object.keys(response).length > 0
        ) {
          res = response.data;
          res.message = processType;
        } else res = {};
      })
      .catch(function (error) {
        if (error.response) {
          errorRes = {
            errorStatus: error.response.status,
            errorMessage: error.response,
          };
        } else if (error.request) {
          errorRes = {
            errorMessage: error.request,
          };
        } else {
          errorRes = { errorMessage: error.message };
        }
        res = errorRes;
      });
    dispatch({
      type: UPDATE_CLIENT_PASSWORD,
      payload: res,
    });
  };
  
  export const blockClient = (blockData, processType) => async (dispatch) => {
    let res = {};
    let errorRes = {
      errorStatus: '',
      errorMessage: '',
    };
    var token = '';
    token = localStorage.getItem('ikar_token');
    await axios
      .post(
        `${mainDomain}/v1/admin/client/block`,
        blockData,
        // ,
        // {
        //   withCredentials: true,
        // }
        {
          headers: {
            Accept: 'application/json',
            Authorization: token,
          },
        }
      )
      .then(function (response) {
        if (
          response !== null &&
          response !== undefined &&
          Object.keys(response).length > 0
        ) {
          res = response.data;
          res.message = processType;
        } else res = {};
      })
      .catch(function (error) {
        if (error.response) {
          errorRes = {
            errorStatus: error.response.status,
            errorMessage: error.response,
          };
        } else if (error.request) {
          errorRes = {
            errorMessage: error.request,
          };
        } else {
          errorRes = { errorMessage: error.message };
        }
        res = errorRes;
      });
    dispatch({
      type: BLOCK_CLIENT,
      payload: res,
    });
  };
  
  export const activeClient = (activeData, processType) => async (dispatch) => {
    let res = {};
    let errorRes = {
      errorStatus: '',
      errorMessage: '',
    };
    var token = '';
    token = localStorage.getItem('ikar_token');
    await axios
      .put(
        `${mainDomain}/v1/admin/confirm`,
        activeData,
        // ,
        // {
        //   withCredentials: true,
        // }
        {
          headers: {
            Accept: 'application/json',
            Authorization: token,
          },
        }
      )
      .then(function (response) {
        if (
          response !== null &&
          response !== undefined &&
          Object.keys(response).length > 0
        ) {
          res = response.data;
          res.message = processType;
        } else res = {};
      })
      .catch(function (error) {
        if (error.response) {
          errorRes = {
            errorStatus: error.response.status,
            errorMessage: error.response,
          };
        } else if (error.request) {
          errorRes = {
            errorMessage: error.request,
          };
        } else {
          errorRes = { errorMessage: error.message };
        }
        res = errorRes;
      });
    dispatch({
      type: ACTIVE_CLIENT,
      payload: res,
    });
  };
  